import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

const getStripeKey = () => {
  const key = window.location.hostname.includes('vercel.app')
    ? import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_TEST
    : import.meta.env.STRIPE_PUBLISHABLE_KEY;

  if (!key) {
    throw new Error('Stripe publishable key is missing');
  }
  return key;
};

/** Lazy singleton — shared by both getStripe() and <Elements> provider */
export const getStripePromise = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(getStripeKey());
  }
  return stripePromise;
};

const getStripe = () => getStripePromise();

export default getStripe; 